/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import { getCustomStyles } from "Config/Config";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";

const ProjectForm = ({
  projectData,
  setProjectField,
  projectTypeList,
  companyList = [],
  setCompanyInput,
  documentUploadHandler,
  saveProjectHandler,
  t,
  isSaving,
}) => {
  return (
    <div className="mt-3 p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
      {/* Basic Info Section */}
      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
        {/* select Type and Company */}
        <div className="row">
          <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Type")} <span className="text-danger">*</span>
            </label>
            <Select
              isClearable
              styles={getCustomStyles(projectData?.validation?.projectType)}
              placeholder={t("e.g., Software Development, Marketing Campaign")}
              options={projectTypeList}
              value={projectData?.projectType}
              onChange={(val) => {
                setProjectField("projectType")(val);
                setProjectField("validation")({
                  ...projectData?.validation,
                  projectType: false,
                });
                setProjectField("error")("");
              }}
            />
            {projectData?.validation?.projectType && (
              <div className="invalid-feedback d-block fs-md">
                {t("Project Type is required")}!
              </div>
            )}
          </div>
          <div className="col-lg-6">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Company")} <span className="text-danger">*</span>
            </label>
            <Select
              styles={getCustomStyles(projectData?.validation?.company)}
              placeholder={t("Select or type company name")}
              isClearable
              options={companyList}
              value={projectData?.company}
              onChange={(val) => {
                setProjectField("company")(val);
                setProjectField("error")("");
              }}
              onInputChange={setCompanyInput}
            />
          </div>
        </div>
      </div>

      {/* Title */}
      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
        <label htmlFor="projectName" className="d-block fs-sm fw-semibold mb-2">
          {t("Project Name")} <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          id="projectName"
          className={`form-control fs-sm shadow-none ${
            projectData?.validation?.title
              ? "is-invalid"
              : "border border-gray-300"
          }`}
          placeholder={t("e.g., Marketing Initiative")}
          value={projectData?.title}
          onChange={(e) => {
            setProjectField("title")(e.target.value);
            setProjectField("validation")({
              ...projectData?.validation,
              title: false,
            });
            setProjectField("error")("");
          }}
        />
        {projectData?.validation?.title && (
          <div className="invalid-feedback fs-md">
            {t("Project Name is required")}!
          </div>
        )}
      </div>

      {/* Summary */}
      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
        <label htmlFor="description" className="d-block fs-sm fw-semibold mb-2">
          {t("Summary")}
        </label>
        <textarea
          name="description"
          id="description"
          cols="30"
          rows="5"
          className="form-control fs-sm shadow-none border border-gray-300"
          placeholder={t(
            "Write a short, high-level overview of the project's main objectives and scope."
          )}
          value={projectData?.summary}
          onChange={(e) => setProjectField("summary")(e.target.value)}
        ></textarea>
      </div>

      {/* Description */}
      <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
        <JoditEditorField
          label={t("Description")}
          labelClassName="d-block fs-sm fw-semibold mb-2"
          value={projectData?.description}
          onChange={(newContent) => setProjectField("description")(newContent)}
        />
      </div>

      {/* Dates */}
      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
        <div className="row">
          <div className="col-md-6 mb-3 mb-md-0">
            <label
              htmlFor="startDate"
              className="d-block fs-sm fw-semibold mb-2"
            >
              {t("Start Date")}
            </label>
            <input
              type="date"
              id="startDate"
              className={`form-control fs-sm shadow-none ${
                projectData?.validation?.endDateIsSmall
                  ? "border-danger"
                  : "border border-gray-300"
              }`}
              value={projectData?.startDate}
              onChange={(e) => {
                setProjectField("startDate")(e.target.value);
                setProjectField("validation")({
                  ...projectData?.validation,
                  endDateIsSmall: false,
                });
                setProjectField("error")("");
              }}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="endDate" className="d-block fs-sm fw-semibold mb-2">
              {t("End Date")}
            </label>
            <input
              type="date"
              id="endDate"
              className={`form-control fs-sm shadow-none ${
                projectData?.validation?.endDateIsSmall
                  ? "border-danger"
                  : "border border-gray-300"
              }`}
              value={projectData?.endDate}
              onChange={(e) => {
                setProjectField("endDate")(e.target.value);
                setProjectField("validation")({
                  ...projectData?.validation,
                  endDateIsSmall: false,
                });
                setProjectField("error")("");
              }}
            />
          </div>
        </div>

        {projectData?.validation?.endDateIsSmall && (
          <div className="invalid-feedback d-block fs-md">
            {t("End Date should be greater than Start Date")}!
          </div>
        )}
      </div>

      {/* Documents Section */}
      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
        <label className="d-block fs-sm fw-semibold mb-2">
          {t("Documents")}
        </label>
        <FileUploadField
          label={t("Upload Documents")}
          accept="doc mp4 pdf"
          onUpload={documentUploadHandler}
          files={projectData?.documents}
          onRemove={(index) => {
            const updatedDocs = [...(projectData?.documents || [])];
            const updatedDocIds = [...(projectData?.documentIds || [])];
            updatedDocs.splice(index, 1);
            updatedDocIds.splice(index, 1);
            setProjectField("documents")(updatedDocs);
            setProjectField("documentIds")(updatedDocIds);
          }}
          loading={projectData?.isUploadingDocs}
          multiple
          fileType="document"
        />
      </div>

      {/* Error Message */}
      {projectData?.error && projectData?.error !== "" && (
        <div className="alert alert-danger" role="alert">
          {projectData?.error}
        </div>
      )}

      <div className="action d-flex flex-wrap gap-3 align-items-center justify-content-between">
        <Link
          to="/admin/projectmanagement/list"
          className="btn btn-outline-primary d-flex align-items-center gap-2"
        >
          <span className="material-symbols-outlined">cancel</span>
          {t("Cancel")}
        </Link>
        <button
          type="button"
          className="btn btn-primary d-flex align-items-center gap-2"
          style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
          disabled={isSaving}
          onClick={saveProjectHandler}
        >
          {isSaving ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              {t("Saving...")}
            </>
          ) : (
            <>
              <span className="material-symbols-outlined">save</span>
              {t("Save Project")}
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ProjectForm;
